import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Catch-all for any path inside the app shell that no route claims. Without it
// React Router matches nothing and the page renders blank.
const NotFound = () => (
  <div className="text-center py-12">
    <h1 className="text-lg font-medium text-gray-900">Page not found</h1>
    <p className="mt-1 text-sm text-gray-500">The page you're looking for doesn't exist.</p>
    <Link
      to="/"
      className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-primary-600 bg-primary-100 hover:bg-primary-200"
    >
      <ArrowLeft className="h-4 w-4 mr-2" aria-hidden="true" />
      Back to Dashboard
    </Link>
  </div>
);

export default NotFound;
